import React from 'react';
import {Property} from "csstype";
import { forwardRefPolymorphic } from "@mrocket/utils";
import { StackRoot } from "./Stack.styles";


export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: Property.FlexDirection,
  gap?: Property.Gap | number,
  grow?: Property.FlexGrow
  shrink?: Property.FlexShrink
  wrap?: Property.FlexWrap
  align?: Property.AlignItems
  justify?: Property.JustifyContent
}

export const Stack = forwardRefPolymorphic<'div', StackProps>((
  {
    children,
    ...props
  },
  ref
) => {


  return (
    <StackRoot
      ref={ref}
      {...props}
    >
      {children}
    </StackRoot>
  );
})

